<lgfg-layout style="display: block;"></lgfg-layout>
<information-modal #informationModal></information-modal>
<confirm-modal #confirmModal></confirm-modal>
<toast #toast></toast>